import { useEffect } from 'react';
import { useHistory } from 'react-router';

const WebformRedirect = ({ entity }) => {
  const history = useHistory();
  const url = entity.get('#url');

  useEffect(() => {
    history.push(url);
  }, [history, url]);

  return null;
};

export default WebformRedirect;
